export const HOSPITAL = {
  name: "서울하이메디컬센터",
  nameEn: "SEOUL HI MEDICAL CENTER",
  slogan: "정확한 진단, 섬세한 치료, 더 나은 일상을 위한 의료 서비스",
  intro:
    "서울하이메디컬센터는 내과, 정형외과, 피부과, 건강검진센터를 함께 운영하는 도심형 종합 클리닉입니다. 환자 중심의 진료 시스템과 디지털 기반 예약/문진 프로세스를 통해 빠르고 편리한 의료 경험을 제공합니다.",
  address: "서울특별시 강남구 테헤란로 128, 하이메디컬타워 5F",
  phone: "02-555-1280",
  fax: "02-555-1281",
  email: "care@seoulhi-medical.com",
  emergencyNote: "응급 증상 시 119 또는 가까운 응급실을 이용해 주세요.",
  bizNo: "123-45-67890",
  ceo: "김서진",
};

export const STATS = [
  { value: "12", unit: "년", label: "운영 경력" },
  { value: "8", unit: "명", label: "전문 의료진" },
  { value: "48,000", unit: "+", label: "누적 진료" },
  { value: "15,200", unit: "+", label: "건강검진 실시" },
];

export const QUICK_SERVICES = [
  { id: "booking", label: "진료 예약", icon: "calendar", target: "booking" },
  { id: "hours", label: "진료 시간", icon: "clock", target: "location" },
  { id: "location", label: "오시는 길", icon: "mapPin", target: "location" },
  { id: "phone", label: "전화 상담", icon: "phone", target: "tel:02-555-1280" },
];

export const NAV_LINKS = [
  { id: "about", label: "병원 소개" },
  { id: "departments", label: "진료과목" },
  { id: "doctors", label: "의료진" },
  { id: "patient", label: "환자 서비스" },
  { id: "checkup", label: "건강검진" },
  { id: "notice", label: "공지·안내" },
  { id: "booking", label: "진료 예약" },
  { id: "location", label: "오시는 길" },
];

export const ADVANTAGES = [
  {
    icon: "calendar",
    title: "당일 진료 예약",
    desc: "온라인 예약 시스템으로 당일 진료 일정을 빠르게 확인하고 예약할 수 있습니다.",
  },
  {
    icon: "stethoscope",
    title: "분야별 전문 의료진",
    desc: "내과·정형외과·피부과·영상의학과 전문의가 협진 체계로 진료합니다.",
  },
  {
    icon: "clipboardList",
    title: "디지털 문진 시스템",
    desc: "방문 전 사전 문진을 작성해 대기 시간을 줄이고 진료 효율을 높입니다.",
  },
  {
    icon: "microscope",
    title: "건강검진 원스톱",
    desc: "검진 상담부터 검사·결과 상담까지 한 곳에서 원스톱으로 진행합니다.",
  },
];

export const DEPARTMENTS = [
  {
    id: "internal",
    name: "내과",
    icon: "heartPulse",
    desc: "소화기·대사질환 및 만성질환을 체계적으로 관리합니다.",
    items: ["소화기 질환", "고혈압/당뇨", "만성질환 관리", "수액 클리닉"],
    hours: "평일 09:00 - 18:00",
  },
  {
    id: "ortho",
    name: "정형외과",
    icon: "bone",
    desc: "척추·관절 통증과 스포츠 손상을 비수술·도수 중심으로 치료합니다.",
    items: ["목/허리 통증", "관절 통증", "스포츠 손상", "도수치료"],
    hours: "평일 09:00 - 19:00",
  },
  {
    id: "derma",
    name: "피부과",
    icon: "scanFace",
    desc: "피부 고민별 맞춤 솔루션으로 자연스러운 개선을 돕습니다.",
    items: ["여드름/흉터", "색소 치료", "리프팅", "스킨부스터"],
    hours: "평일 10:00 - 19:00",
  },
  {
    id: "checkup",
    name: "건강검진센터",
    icon: "clipboardCheck",
    desc: "연령·직군·건강 상태에 맞춘 맞춤형 검진 프로그램을 운영합니다.",
    items: ["기본 건강검진", "직장인 검진", "암 검진", "맞춤형 정밀검진"],
    hours: "평일·토 08:00 - 14:00",
  },
];

export const DOCTORS = [
  {
    name: "김서진 원장",
    role: "내과 전문의",
    focus: "소화기·만성질환",
    initials: "김",
    schedule: "월·수·금 오전 / 화·목 오후",
    career: "서울대학교 의과대학 졸업 · 전 서울대병원 내과 임상강사",
  },
  {
    name: "이도윤 원장",
    role: "정형외과 전문의",
    focus: "척추·관절",
    initials: "이",
    schedule: "월·화·목 전일 / 수 오전",
    career: "연세대학교 의과대학 졸업 · 대한정형외과학회 정회원",
  },
  {
    name: "박하은 원장",
    role: "피부과 전문의",
    focus: "피부재생·색소치료",
    initials: "박",
    schedule: "화·수·금 전일 / 토 오전",
    career: "성균관대학교 의과대학 졸업 · 대한피부과학회 정회원",
  },
  {
    name: "최민재 원장",
    role: "영상의학과 전문의",
    focus: "건강검진 판독",
    initials: "최",
    schedule: "월~금 오전 (검진 판독)",
    career: "고려대학교 의과대학 졸업 · 건강검진 판독 10년+",
  },
];

export const BOOKING_STEPS = [
  { step: "01", title: "진료과 선택", desc: "내과·정형외과·피부과·건강검진 중 선택" },
  { step: "02", title: "날짜/시간 선택", desc: "실시간 예약 가능 시간 확인" },
  { step: "03", title: "사전 문진 작성", desc: "모바일·PC에서 간편 문진" },
  { step: "04", title: "예약 확정", desc: "문자·카카오 알림으로 안내" },
];

export const PATIENT_TABS = [
  { id: "lookup", label: "예약 조회", icon: "search" },
  { id: "questionnaire", label: "사전 문진", icon: "fileText" },
  { id: "checkup-result", label: "검진 결과", icon: "fileBarChart" },
  { id: "inquiry", label: "1:1 문의", icon: "messageSquare" },
];

export const CHECKUP_PACKAGES = [
  {
    name: "Basic Check-up",
    price: "150,000원",
    desc: "기본 건강 상태를 확인하는 표준 검진 패키지",
    items: ["기초 혈액검사", "소변검사", "흉부 X-ray", "복부 초음파", "결과 상담"],
  },
  {
    name: "Premium Check-up",
    price: "390,000원",
    featured: true,
    desc: "직장인·40대 이상을 위한 정밀 검진 패키지",
    items: ["종합 혈액검사", "심전도", "갑상선 초음파", "위 내시경", "전문의 상담"],
  },
  {
    name: "Executive Check-up",
    price: "790,000원",
    desc: "종합 정밀 검진과 맞춤형 암·심혈관 스크리닝",
    items: ["MRI/CT 선택", "암 표지자 검사", "심혈관 정밀", "영양·운동 상담", "1:1 결과 리포트"],
  },
];

export const FACILITIES = [
  { name: "접수 라운지", desc: "밝고 쾌적한 프라이빗 대기 공간", tone: "linear-gradient(145deg,#e8f4f8,#d4e8f0)" },
  { name: "진료실", desc: "환자 프라이버시를 고려한 1인 진료실", tone: "linear-gradient(145deg,#eef2f6,#dfe8f0)" },
  { name: "검진센터", desc: "최신 장비 기반 원스톱 검진 공간", tone: "linear-gradient(145deg,#e6f2ef,#d0e8e2)" },
  { name: "치료실", desc: "도수·재활 치료 전용 케어 룸", tone: "linear-gradient(145deg,#f0f4f8,#e2eaf2)" },
  { name: "회복실", desc: "수액·검진 후 편안한 휴식 공간", tone: "linear-gradient(145deg,#f5f8fa,#e8eef4)" },
];

export const NOTICES = [
  { id: 1, category: "공지", title: "2026년 설 연휴 진료 일정 안내", date: "2026.01.28", pinned: true },
  { id: 2, category: "검진", title: "직장인 맞춤 건강검진 패키지 예약 접수", date: "2026.02.10", pinned: false },
  { id: 3, category: "진료", title: "도수치료실 운영 시간 변경 안내", date: "2026.02.15", pinned: false },
  { id: 4, category: "안내", title: "사전 문진 모바일 작성 서비스 오픈", date: "2026.03.01", pinned: false },
  { id: 5, category: "공지", title: "비급여 진료비 항목 및 수가표 개정", date: "2026.03.12", pinned: false },
];

export const HEALTH_ARTICLES = [
  {
    title: "만성질환, 정기 검진으로 관리하세요",
    category: "내과",
    date: "2026.03.05",
    summary: "고혈압·당뇨 환자를 위한 생활 습관과 정기 검진 주기를 안내합니다.",
  },
  {
    title: "목·허리 통증, 방치하지 마세요",
    category: "정형외과",
    date: "2026.02.22",
    summary: "일상 속 자세 교정과 초기 치료가 중요한 이유를 설명합니다.",
  },
  {
    title: "검진 전 24시간, 이렇게 준비하세요",
    category: "건강검진",
    date: "2026.02.08",
    summary: "금식·복용 약 조정 등 검진 당일을 위한 체크리스트입니다.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "처음 방문 시 준비물이 있나요?",
    a: "신분증과 기존 진료 기록·복용 약 목록이 있으면 진료에 도움이 됩니다. 건강보험증은 전자 시스템으로 확인 가능합니다.",
  },
  {
    q: "당일 예약이 가능한가요?",
    a: "진료과별 잔여 슬롯이 있는 경우 당일 예약이 가능합니다. 온라인 예약 또는 전화(02-555-1280)로 문의해 주세요.",
  },
  {
    q: "사전 문진은 언제 작성하나요?",
    a: "예약 확정 후 문자로 안내되는 링크를 통해 방문 1일 전까지 작성하실 수 있습니다. 현장 접수 시 태블릿으로도 작성 가능합니다.",
  },
  {
    q: "건강검진 결과는 언제 받을 수 있나요?",
    a: "기본 검진은 3~5영업일, 정밀 검진은 7~10영업일 내 결과 상담 일정을 안내해 드립니다.",
  },
  {
    q: "주차 시설이 있나요?",
    a: "하이메디컬타워 지하 2~4층 주차장을 이용하실 수 있으며, 진료·검진 고객에게 2시간 무료 주차를 제공합니다.",
  },
];

export const NON_COVERED_ITEMS = [
  { name: "도수치료 (1회)", price: "80,000원", note: "비급여" },
  { name: "스킨부스터 시술", price: "350,000원~", note: "비급여" },
  { name: "프리미엄 건강검진", price: "390,000원~", note: "선택검진" },
  { name: "MRI (부위별)", price: "450,000원~", note: "비급여/선택" },
  { name: "색소 레이저 치료", price: "150,000원~", note: "비급여" },
];

export const TREATMENT_GUIDE = [
  {
    title: "초진 안내",
    icon: "userPlus",
    items: ["접수 → 문진 작성 → 진료 대기", "신분증 지참", "예약 시간 10분 전 도착 권장"],
  },
  {
    title: "재진 안내",
    icon: "refreshCw",
    items: ["접수 → 진료 대기", "처방전·검사 결과 지참", "당일 예약 시 대기 시간 단축"],
  },
  {
    title: "검진 안내",
    icon: "clipboardCheck",
    items: ["금식 8시간 (물 섭취 가능)", "복용 약 사전 상담", "검진 후 회복실 휴식 제공"],
  },
];

export const HOURS = [
  { label: "평일", time: "09:00 - 19:00" },
  { label: "토요일", time: "09:00 - 14:00" },
  { label: "점심시간", time: "13:00 - 14:00" },
  { label: "일요일/공휴일", time: "휴진" },
];

export const TRANSPORT = [
  { type: "지하철", info: "2호선 역삼역 3번 출구 도보 5분" },
  { type: "버스", info: "간선 146, 360 · 지선 3412, 4312" },
  { type: "주차", info: "지하 2~4층 · 진료·검진 고객 2시간 무료" },
];

export const DEPT_OPTIONS = DEPARTMENTS.map((d) => d.name);

export const LEGAL_LINKS = [
  { id: "privacy", label: "개인정보처리방침" },
  { id: "terms", label: "이용약관" },
  { id: "non-covered", label: "비급여 안내" },
  { id: "rights", label: "환자권리장전" },
];
